<template>
  <div class="mall-shop-home">
    <MallQuickMenu @click="$emit('quick-menu-click', $event)" />
    <div class="mall-shop-home__content">
      <!-- 최근 구매 상품 (구매 이력이 있을 때만) -->
      <template v-if="recentItems.length > 0">
        <MallRecentPurchase
          :tabs="recentTabs"
          :items="recentItems"
          @more-click="$emit('recent-more-click')"
          @rebuy-click="$emit('product-click', $event)"
        />
        <div class="mall-shop-home__thick-divider"></div>
      </template>

      <div class="mall-shop-home__sections">
        <template v-for="(section, index) in sections">
          <div v-if="index > 0" :key="'divider-' + section.key" class="mall-shop-home__divider"></div>
          <MallCategorySection
            :key="section.key"
            :heading="index === 0 ? '어떤 상품을 찾으세요?' : ''"
            :title="section.title"
            :products="section.products"
            @more-click="$emit('more-click', section.key)"
            @product-click="$emit('product-click', $event)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import MallQuickMenu from '@/components/new/molecules/MallQuickMenu.vue'
import MallRecentPurchase from '@/components/new/organisms/MallRecentPurchase.vue'
import MallCategorySection from '@/components/new/organisms/MallCategorySection.vue'

export default {
  name: 'MallShopHome',
  components: {
    MallQuickMenu,
    MallRecentPurchase,
    MallCategorySection,
  },
  props: {
    // [{ key, title, products }]
    sections: {
      type: Array,
      required: true,
    },
    // [{ key, label }]
    recentTabs: {
      type: Array,
      required: true,
    },
    recentItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.mall-shop-home__content {
  display: flex;
  margin-top: 1px;
  padding: 16px 0 32px 0;
  flex-direction: column;
  gap: 24px;
}

.mall-shop-home__thick-divider {
  height: 12px;
  background: #F2F4F6;
}

.mall-shop-home__sections {
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  gap: 24px;
}

.mall-shop-home__divider {
  height: 1px;
  background: #E5E8EB;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallShopHome.vue